import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app/App';
import reportWebVitals from './reportWebVitals';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './assets/css/views/index.css';
    
ReactDOM.render(
    <React.StrictMode>
        <App></App>
    </React.StrictMode>
    ,
    document.getElementById('root')
)   

serviceWorkerRegistration.register();
reportWebVitals();

